
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'no-partner-component',
  templateUrl: './no-partner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:true,
  imports: [
    TranslateModule,
    ButtonModule
]
})
export class NoPartnerComponentComponent {
  readonly onAction = output<{ action: string }>();
  addModal(){
    this.onAction.emit({action:"createPartner"});
  }

}
